import React from 'react'

import Container from 'components/atoms/Container'
import SectionContainer from 'components/atoms/SectionContainer'
import Typography from 'components/atoms/Typography'

import Relazsizes from 'relazsizes'

import config from 'config'

const { assets_url: assetsUrl } = config
const pintariaAssetsPath = `${assetsUrl}/assets/img/pintaria/description`

const PintariaDescription = () => (
  <div className="pintaria-description">
    <SectionContainer paddingBottom={80} paddingTop={80} backgroundColor="transparent">
      <Container>
        <div className="pintaria-description__row">
          <div className="pintaria-description__col center">
            <Relazsizes src={`${pintariaAssetsPath}/pintaria-logo.png`} className="pintaria-description__logo" />
          </div>
          <div className="pintaria-description__col">
            <Typography component="h3" variant="title" className="text-variant-title-sm">Apa itu Pintaria?</Typography>
            <Typography component="p" variant="body">
              Pintaria merupakan portal pendidikan yang menawarkan produk kuliah S1/S2 dengan metode blended learning dan program kursus lainnya. Pintaria bekerjasama dengan kampus-kampus unggulan yang terakreditasi BAN-PT di Indonesia.
            </Typography>
          </div>
        </div>
        <div className="pintaria-description__row">
          <div className="pintaria-description__col">
            <Typography component="h3" variant="title" className="text-variant-title-sm">Tentang Pintaria?</Typography>
            <Typography component="p" variant="body">
              Pintaria solusi kuliah tanpa ganggu kerjaan, dengan banyak pilihan kampus dan beragam jurusan.
            </Typography>
          </div>
          <div className="pintaria-description__col">
            <Relazsizes src={`${pintariaAssetsPath}/pintaria-image.jpg`} className="pintaria-description__img" />
          </div>
        </div>
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .pintaria-description {
          :global(&__logo) {
            height: 80px;
            display: block;
            margin: auto;
          }
          :global(&__img) {
            height: 220px;
            display: block;
            margin: auto;
          }
          &__row {
            display: flex;
            justify-content: center;
            align-items: stretch;
          
            &:not(:first-child) {
              margin-top: 48px;
            }
          }
          &__col {
            flex-basis: 50%;

            &.center {
              align-self: center;
            }
          }
          @media screen and (min-width:768px) {
            background: url('${pintariaAssetsPath}/combined-shape.svg') no-repeat,
                      url('${pintariaAssetsPath}/combined-shape-2.svg') no-repeat,
                      #fff no-repeat;
            background-position: top 7% left 18%, top 40% right 10%;
          }
          @media screen and (max-width: 767px) {
            background-color: #fff;
            :global(&__img) {
              display: none;
            }

            &__row {
              flex-direction: column;
            }
            &__col {
              &.center {
                order: 2;
                margin-top: 32px;
              }
            }
          }
        }
      `}
    </style>
  </div>
)

export default PintariaDescription
